import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import type { SearchItem, SearchSources } from "@/shared/components/GlobalSearch";
import { navSections } from "@/portals/caregiver/layout/CaregiverSidebar";
import { useCaregiverPatients } from "@/portals/caregiver/context/CaregiverPatientsContext";

/**
 * The caregiver header search: their pages and the patients they care for
 * (picking one opens My Patients with that patient selected). Runs only
 * while the search dropdown is open.
 */
export function useCaregiverSearch(): SearchSources {
  const navigate = useNavigate();
  const { patients, setActivePatientId } = useCaregiverPatients();

  const items = useMemo<SearchItem[]>(() => {
    const out: SearchItem[] = [];
    for (const section of navSections) {
      for (const page of section.items) {
        out.push({ id: page.path, group: "Pages", title: page.label, subtitle: section.title, icon: page.icon, to: page.path });
      }
    }
    for (const p of patients) {
      out.push({
        id: p.id, group: "My patients", title: p.name, icon: "lucide:user-round",
        subtitle: `${p.categoriesSharedCount} of ${p.categoriesTotalCount} categories shared${p.status !== "active" ? ` · ${p.status}` : ""}`,
        keywords: "patient", to: () => { setActivePatientId(p.id); navigate("/caregiver"); },
      });
    }
    return out;
  }, [patients, setActivePatientId, navigate]);

  return { items };
}
